import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';

import TagField from '../TagField';

const TagFieldWrapper = ({ name, ...props }) => {
  return (
    <Field
      name={name}
      render={({ field, form: { errors, touched, submitCount, values } }) => {
        const errorMessage =
          ((touched && touched[field.name]) || submitCount > 0) &&
          errors &&
          errors[field.name];

        return (
          <TagField
            field={field}
            errorMessage={errorMessage}
            type={values?.ruleType}
            values={values}
            {...props}
          />
        );
      }}
    />
  );
};

TagFieldWrapper.propTypes = {
  name: PropTypes.string.isRequired,
};

export default TagFieldWrapper;
